import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/common/Header';
import Footer from './components/common/Footer';

// Pages
import Home from './pages/Home';
import Shop from './pages/shop/Shop';
import BirthChart from './pages/services/BirthChart';
import Consultations from './pages/services/Consultations';
import CosmicMap from './pages/CosmicMap';
import Cart from './pages/checkout/Cart';
import Checkout from './pages/checkout/Checkout';
import Success from './pages/checkout/Success';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import RefundPolicy from './pages/RefundPolicy';
import TermsAndServices from './pages/TermsAndServices';

const App: React.FC = () => {
  return (
    <Router>
      <div className="flex flex-col min-h-screen bg-midnight text-white">
        <Header />
        <main className="flex-grow pt-20">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/services/birth-chart" element={<BirthChart />} />
            <Route path="/services/consultations" element={<Consultations />} />
            <Route path="/cosmic-map" element={<CosmicMap />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/success" element={<Success />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/terms-and-services" element={<TermsAndServices />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
